<template>
    
    <div class="content">
        <div class="header">
            <div class="search">
                <span class="title">姓名：</span>
                <el-input v-model="name" placeholder="请输入姓名"></el-input>
                <span class="title">完成情况：</span>
                <el-select v-model="status" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">

                    </el-option>
                </el-select>
                <el-button type="primary" size="small" @click="Form()">查询</el-button>
                <el-button size="small" @click="clearSearch">清空</el-button>
            </div>
            <el-button type="primary" size="small" @click="addVisible = true">添加智能体测</el-button>
        </div>
        
        
        <div class="time">
            <span>{{default_class.class_name}}{{default_class.type_name}}</span>
            <span>人数：{{tableData.length}}/{{studentlist.length}}</span>
        </div>
        <div class="matable">
            <el-table border style="width: 100%" :data="tableData">
                <el-table-column align="center" prop="id" label="编号" ></el-table-column>
                <el-table-column align="center" prop="username" label="姓名" ></el-table-column>
                <el-table-column align="center" prop="height" label="身高(米)" ></el-table-column>
                <el-table-column align="center" prop="weight" label="体重(kg)" ></el-table-column>
                <el-table-column align="center" prop="vital" label="肺活量(cc)" ></el-table-column>
                <el-table-column align="center" prop="sit_forward" label="坐位体前屈(个)" ></el-table-column>
                 <el-table-column align="center" prop="skipping" label="跳绳(个)" ></el-table-column>
                  <el-table-column align="center" prop="lie" label="仰卧起坐(个)" ></el-table-column>
                   <el-table-column align="center" prop="longjump" label="立定跳远(个)" ></el-table-column>
                <el-table-column align="center" prop="roundtrip" label="50米*8(s)"></el-table-column>
                <el-table-column align="center" prop="run" label="50米跑(s)"  ></el-table-column>
                <el-table-column align="center" prop="status" label="完成度"  ></el-table-column>
            </el-table>
        </div>
                        <!-- 添加学生 -->
        <el-dialog title="添加智能体测数据"  :append-to-body="true" :visible.sync="addVisible" width="500px">
            <el-form :model="add_form">
                <!-- <el-form-item label="所在班级" >
                <el-select class="w-100" v-model="add_form.class_id" placeholder="请选择班级" @change="selectInspectType(add_form.class_id)">

                    <label v-for="(item,index) in class_list" :key="index">
                        <el-option :label="item.classlist.class_name+item.classlist.type_name" :value="item.class_id"></el-option>
                        </label>wa
                </el-select>
                </el-form-item> -->
              <el-form-item label="学生" >


                <el-select
                    v-model="student_item"
                    style="width:100%"
                    placeholder="请选择学生"
                    value-key="id"
                    @change="selectStudentType(student_item)"
                    >
                    <el-option
                        v-for="opt in studentlist"
                        :key="opt.id"
                        :label="opt.username"
                        :value="opt"
                    />
                </el-select>
                </el-form-item>

                <el-form-item label="身高" >
                <el-input v-model="add_form.height" autocomplete="off"  placeholder="请输入身高" style="width:100%"></el-input>
                </el-form-item>

                <el-form-item label="体重" >
                <el-input v-model="add_form.weight" autocomplete="off" placeholder="请输入体重" style="width:100%"></el-input>
                </el-form-item>
                
                <el-form-item label="肺活量" >
                <el-input v-model="add_form.vital" autocomplete="off" placeholder="请输入肺活量" style="width:100%"></el-input>
                </el-form-item>

                <el-form-item label="坐位体前屈" >
                <el-input v-model="add_form.sit_forward" autocomplete="off" placeholder="请输入坐位体前屈" style="width:100%"></el-input>
                </el-form-item>

                <el-form-item label="跳绳" >
                <el-input v-model="add_form.skipping" autocomplete="off" placeholder="请输入跳绳" style="width:100%"></el-input>
                </el-form-item>

                <el-form-item label="仰卧起坐" >
                <el-input v-model="add_form.lie" autocomplete="off" placeholder="请输入仰卧起坐" style="width:100%"></el-input>
                </el-form-item>

                <el-form-item label="立定跳远" >
                <el-input v-model="add_form.longjump" autocomplete="off" placeholder="请输入立定跳远" style="width:100%"></el-input>
                </el-form-item>
                

                <el-form-item label="50米*8" >
                <el-input v-model="add_form.roundtrip" autocomplete="off" placeholder="请输入50米*8" style="width:100%"></el-input>
                </el-form-item>

                <el-form-item label="50米跑" >
                <el-input v-model="add_form.run" autocomplete="off" placeholder="请输入50米跑" style="width:100%"></el-input>
                </el-form-item>

                <el-form-item label="完成度" >


                <el-select
                    v-model="add_form.status"
                    style="width:100%"
                    placeholder="请选择"
                    value-key="id"
                    >
                    <el-option
                        label="完成"
                        value="1"
                    />
                    <el-option
                        label="未完成"
                        value="0"
                    />
                </el-select>
                </el-form-item>
                

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="confirmAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
    
</template>
    




<script>
    import { mapState } from 'vuex'
    import {sports,studentList,intelligence} from '@/api/notice'
    export default {
        data(){
            return{
                student_item:'',
                name:'',
                status:'',
                value:'',
                addVisible:false,
                options:[
                    {
                        value: '1',
                        label: '完成'
                    },
                    {
                        value: '2',
                        label: '未完成'
                    }
                ],
                tableData:[
                    
                ],
                add_form:{
                    user_id:'',
                    height:'',
                    weight:'',
                    class_id:'',
                    vital:'',
                    sit_forward:'',
                    skipping:'',
                    lie:'',
                    longjump:'',
                    roundtrip:'',
                    run:'',
                    username:'',
                    status:''

                },
                studentlist:[]
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.system.userInfo,
                default_class: state => state.system.default_class
            }),
        },
        created(){
            this.getkaoqin()
            this.selectInspectType()
        },
        methods: {
            cancel () {
      // 重置form表单
            this.add_form = {
                    user_id:'',
                    height:'',
                    weight:'',
                    class_id:'',
                    vital:'',
                    sit_forward:'',
                    skipping:'',
                    lie:'',
                    longjump:'',
                    roundtrip:'',
                    run:'',
                    username:'',
                    status:''

                },
                this.student_item = ''
            // 关闭dialog
            this.addVisible = false
            },
            confirmAdd(){
                
                intelligence({form:JSON.stringify(this.add_form)}).then(res=>{
                    console.log('提示',res);
                    if(res.code == 0){
                        
                        this.$message.error(res.msg);
                        
                    }else{
                        this.addVisible = false
                        this.getkaoqin()
                        this.student_item = ''
                        this.add_form = {
                            user_id:'',
                            height:'',
                            weight:'',
                            class_id:'',
                            vital:'',
                            sit_forward:'',
                            skipping:'',
                            lie:'',
                            longjump:'',
                            roundtrip:'',
                            run:''

                        }
                    }
                    
                })
            },
            selectStudentType(StudentType){
                this.add_form.username = StudentType.username
                this.add_form.user_id = StudentType.id
                this.add_form.class_id = this.default_class.id
            },
            selectInspectType(){
                console.log(this.add_form)
                studentList({class_id:this.default_class.id}).then(res=>{
                    if(res.data.length > 0){
                        this.studentlist = res.data
                    }
                })
            },
            Form(){
                this.getkaoqin();
            },
            getkaoqin(){
                sports({class_id:this.default_class.id,name:this.name,status:this.status}).then(res=>{
                    this.tableData = res.data
                    console.log('数据',this.item)
                })
            },
            clearSearch(){
                this.name = ''
                this.status = ''
                this.pageIndex = 1;
                this.getkaoqin()
            },
        } 
    }
    </script>

<style lang="scss" scoped>
    .el-form-item{margin-bottom:0 !important}
    .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
}
.content{
    width:100%;
    .search{
        padding:20px 0;
        background:#fff;
        display:flex;
        align-items:center;
        .title{
            color:#000;
            padding-right:10px;
        }
        .el-input{
            margin-right:10px;
            width:auto !important;
        }
        button{
            margin-left:10px;
        }
        .rightbtns{
            margin-left:auto;
            display:flex;
            align-items:center;
        }
    }
    .time{
        display:flex;
        align-items:center;
        span{
            color:#000;
            margin-right:20px;
        }
        padding-bottom:10px;
    }
}
</style>
